export default "__VITE_ASSET__a6b1aa89__"